import { gql, useMutation } from '@apollo/client';
import { Locales } from '@components/block/Header/LangSelect';
import { useTranslation } from 'react-i18next';
import { GET_USER } from './useUserQuery';

const LOGIN_USER = gql`
  mutation LoginUser($email: String!, $password: String!, $token: String, $locale: String) {
    loginUser(email: $email, password: $password, token: $token, locale: $locale)
  }
`;

export interface UserLoginInput {
  email: string;
  password: string;
  token?: string;
  locale?: Locales;
}

export interface UserLoginResult {
  loginUser: boolean;
}

export function useUserLoginMutation() {
  const { i18n } = useTranslation();
  return useMutation<UserLoginResult, UserLoginInput>(LOGIN_USER, {
    refetchQueries: [{ query: GET_USER }],
    awaitRefetchQueries: true,
    onCompleted(data) {
      // Language change will happen in the useUserQuery onCompleted after refetch
    },
  });
}
